/**
 * * Установить время конца
 */
export default class TaskTimerCloseTimerRequest  {
	/**
	 * * Ид таймера который остановить
	 */
	TimerId!: number;
	constructor(obj?: Partial<TaskTimerCloseTimerRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
